import React, { useEffect, useMemo } from 'react';
const DEFAULT_TITLE = 'Conviva Pulse';

function usePageTitle({ text = DEFAULT_TITLE }) {

  // change title on mount and unmount
  useEffect(() => {
    document.title = `${text}`;

    return () => {
      document.title = DEFAULT_TITLE;
    }
  }, [text]);
}

export default usePageTitle;
